import { useState } from "react";
// Styles
import DialogButtonDivStyled from "components/elements/DialogButtonDivStyled";
import DialogButtonStyled from "components/elements/DialogButtonStyled";
import FormStyled from "components/forms/FormStyled";
import FormStyledError from "components/forms/FormStyledError";
// Services
import { ControlCatalogCreateDto } from "@kdmanalytics/brm-knowledgebase";
import { GlobalControlApi } from "features/brm";
import PropTypes from "prop-types";
// State
import { controlCatalogAddedState } from "atoms/atoms-global-control";
import { useRecoilState } from "recoil";
// Components
import TextField from "components/forms/TextField";
// Constants
import { FORM_PLACEHOLDER, FORM_LABEL, FORM_ERROR } from "constants/brm";

export const AddControlCatalogForm = ({ setModalIsOpen }) => {
  const STANDARD = "NIST-800-53";
  const [postError, setPostError] = useState("");
  const [, setControlCatalogAdded] = useRecoilState(controlCatalogAddedState);
  const [isTextValid, setIsTextValid] = useState(true);
  const { mutate: createControlCatalog } = GlobalControlApi.useCreateControlCatalog();

  // validate that all fields in the form have been completed
  function validate(formData) {
    let error = true;
    if (formData.name.value === "") {
      error = false;
    }
    return error;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const isValid = validate(e.target.elements);

    if (isValid && isTextValid) {
      // the new instance from user - form entry
      const params = {
        standard: e.target.elements.standard.value || STANDARD,
        note: e.target.elements.note.value || "",
        name: e.target.elements.name.value,
      };

      const controlCatalogCreateDto = ControlCatalogCreateDto.constructFromObject(params);

      // send new instance to the backend - instance is created in context of project
      createControlCatalog(
        { controlCatalogCreateDto },
        {
          onSettled: () => {
            setModalIsOpen(false);
            setControlCatalogAdded(true); // update the added state so the dropdown can be updated
          },
        }
      );
    } else {
      return isTextValid ? setPostError(FORM_ERROR.missingFields) : setPostError(FORM_ERROR.invalidCharacters);
    }
    return null;
  }

  return (
    <div>
      <form onSubmit={handleSubmit} action="">
        <FormStyled>
          <div className="form-style">
            <TextField
              label={{ id: "ControlCatalogAddForm_name", name: FORM_LABEL.nameMandatory }}
              input={{ name: "name", placeholder: FORM_PLACEHOLDER.name }}
              setIsTextValid={setIsTextValid}
            />
            <TextField
              label={{ id: "ControlCatalogAddForm_note", name: FORM_LABEL.note }}
              input={{ name: "note", placeholder: FORM_PLACEHOLDER.note }}
              setIsTextValid={setIsTextValid}
            />
            <TextField
              label={{ id: "ControlCatalogAddForm_standard", name: FORM_LABEL.standardOptional }}
              input={{ name: "standard", placeholder: STANDARD }}
              setIsTextValid={setIsTextValid}
            />
          </div>
        </FormStyled>
        <FormStyledError>{postError}</FormStyledError>
        <DialogButtonDivStyled>
          <DialogButtonStyled onClick={() => setModalIsOpen(false)}>Cancel</DialogButtonStyled>
          <DialogButtonStyled type="submit">Add</DialogButtonStyled>
        </DialogButtonDivStyled>
      </form>
    </div>
  );
};

AddControlCatalogForm.propTypes = {
  setModalIsOpen: PropTypes.func.isRequired,
};
